import { render, staticRenderFns } from "./zoneManagement.vue?vue&type=template&id=0c10f584&scoped=true&"
import script from "./zoneManagement.vue?vue&type=script&lang=js&"
export * from "./zoneManagement.vue?vue&type=script&lang=js&"
import style0 from "./zoneManagement.vue?vue&type=style&index=0&id=0c10f584&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10f584",
  null
  
)

export default component.exports